import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/Home.vue'
import BioPage from '../views/Bio.vue'
import ServicesDetail from '../views/ServicesDetail.vue'
import ServicesPage from '../views/Services.vue'
import AboutPage from '../views/About.vue'
import CaseStudiesPage from '../views/CaseStudies.vue'
import NotFoundPage from '../views/NotFound.vue'
import { DEFAULT_PAGE_META, JOIN_PAGE_META } from '../constants/pageMeta'
import { applyPageMeta } from '../utils/pageMeta'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: {
      ...DEFAULT_PAGE_META,
      canonicalPath: '/'
    }
  },
  {
    path: '/bio',
    name: 'Bio',
    component: BioPage,
    meta: {
      title: 'About Nadra Aley - Safe Haven Wellness Group'
    }
  },
  {
    path: '/interventions',
    name: 'Interventions',
    component: ServicesPage,
    meta: {
      title: 'Interventions & Services - Safe Haven Wellness Group'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage,
    meta: {
      title: 'Core Pillars & Mission - Safe Haven Wellness Group'
    }
  },
  {
    path: '/case-studies',
    name: 'CaseStudies',
    component: CaseStudiesPage,
    meta: {
      title: 'News, Reports & Media - Safe Haven Wellness Group'
    }
  },
  {
    path: '/join',
    name: 'Join',
    component: HomePage,
    meta: {
      ...JOIN_PAGE_META,
      includeJsonLd: true
    }
  },
  {
    path: '/interventions/:id',
    name: 'ServicesDetail',
    component: ServicesDetail,
    meta: {
      title: 'Service Details - Safe Haven Wellness Group'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundPage,
    meta: {
      title: 'Page Not Found - Safe Haven Wellness Group'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) {
      return { el: to.hash, top: 100, behavior: 'smooth' }
    }
    return { top: 0, behavior: 'smooth' }
  }
})

function resolveRouteMeta(to) {
  if (to.name === 'Join' || to.hash === '#join') {
    return { ...JOIN_PAGE_META, includeJsonLd: true }
  }

  if (to.meta?.title || to.meta?.description) {
    return {
      title: to.meta.title,
      description: to.meta.description,
      canonicalPath: to.path,
      ogImage: DEFAULT_PAGE_META.ogImage,
      ogImageAlt: DEFAULT_PAGE_META.ogImageAlt,
      ogType: DEFAULT_PAGE_META.ogType,
      twitterCard: DEFAULT_PAGE_META.twitterCard,
      robots: to.meta.robots || DEFAULT_PAGE_META.robots,
      includeOrganizationJsonLd: to.path === '/'
    }
  }

  return {
    ...DEFAULT_PAGE_META,
    canonicalPath: to.path || '/',
    includeOrganizationJsonLd: to.path === '/'
  }
}

router.afterEach((to) => {
  applyPageMeta(resolveRouteMeta(to))
})

export default router
